import { useState } from "react";
import useSettingsActions from "../../../hooks/actions/settings.actions";

const useUpdateEmailPhone = ({
  refreshData = () => {}
} = {}) => {
  const [isLoading, setIsLoading] = useState(false);
  const { updateEmailPhone } = useSettingsActions();

  const updateEmailPhoneHandler = async ({ email, phone }) => {
    setIsLoading(true);
    try {
      const response = await updateEmailPhone({ email, phone });
      refreshData();
      return response;
    } catch (error) {
      console.log(error);
    } finally {
      setIsLoading(false);
    }
  }

  return {
    isLoading,
    updateEmailPhoneHandler
  }
}

export default useUpdateEmailPhone;
